import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoMediaDevice = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 2,
	height: 12,
	viewBox: "0 0 2 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1 0.5V7.5",
		stroke: "white",
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M1 11.5C1.55228 11.5 2 11.0523 2 10.5C2 9.94772 1.55228 9.5 1 9.5C0.447715 9.5 0 9.94772 0 10.5C0 11.0523 0.447715 11.5 1 11.5Z",
		fill: "white"
	})]
});
export default SvgNoMediaDevice;
